// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumbs__list{display:flex}.breadcrumbs__item{@apply text-gray-500 text-sm}.breadcrumbs__item:not(:last-child){@apply hover:text-gray-900 mr-3}.breadcrumbs__item:not(:last-child):after{@apply ml-2;content:\"/\"}.breadcrumbs__item.active{@apply text-gray-700 font-semibold}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
